import React from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Translate from "../../../../translate/Translate";
import { useLogout } from "../../../../hooks/useLogout";
import { useAuth0 } from "@auth0/auth0-react";
import { validateToken } from "../../../../utils/utils";
import { getCookie } from "utils/v3/CookieUtil";
import { HeaderItem } from "./index";
import { COLORS } from "../../Theme/colors";
import hamburgerIcon from "../../../../assets/icons/Hamburger.svg";

interface HamburgerNavProps {
  menuItems: HeaderItem[];
}

const HamburgerNav: React.FC<HamburgerNavProps> = ({ menuItems }) => {
  const [open, setOpen] = React.useState(false);
  const logoutFunction = useLogout();
  const { loginWithRedirect } = useAuth0();
  const sessionIsValid = validateToken(getCookie("accessToken"));

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        aria-label="open menu"
        id="menuIcon"
        onClick={handleDrawerOpen}
        sx={{
          color: COLORS.PRIMARY_DARKER
        }}
      >
        <img src={hamburgerIcon} alt="" />
      </IconButton>
      <Drawer
        anchor="right"
        open={open}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            width: 200,
            p: 3
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mb: 1
          }}
        >
          <IconButton
            onClick={handleDrawerClose}
            aria-label="close menu"
            sx={{
              color: COLORS.PRIMARY_DARKER
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.id} disablePadding sx={{ mb: 1 }}>
              <NavLink
                to={item.route}
                id={item.id}
                onClick={handleDrawerClose}
                style={{
                  width: "100%",
                  textDecoration: "none",
                  color: COLORS.PRIMARY_DARKER
                }}
              >
                <Typography variant="body" sx={{ p: 0 }}>
                  <Translate text={item.name} />
                </Typography>
              </NavLink>
            </ListItem>
          ))}
          <ListItem disablePadding sx={{ mb: 1 }}>
            <Box
              component="a"
              href="#"
              id={"logOut"}
              onClick={(e) => {
                e.preventDefault();
                handleDrawerClose();
                if (sessionIsValid) {
                  logoutFunction();
                } else {
                  loginWithRedirect();
                }
              }}
              sx={{
                width: "100%",
                mt: 2,
                pt: 2,
                textDecoration: "none",
                borderTop: `1px solid ${COLORS.GRAY}`
              }}
            >
              <Typography variant="body_error" sx={{ p: 0 }}>
                <Translate text={sessionIsValid ? "Log Out" : "Log In"} />
              </Typography>
            </Box>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default HamburgerNav;
